<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Transaksi Kas Masuk</h5>
            </template>
            <b-button class="mb-3" variant="pgiBtn" @click="inputKasMasuk" name="kasMasukAddBtn">Input Kas Masuk</b-button>
            <b-table bordered hover show-empty 
                :fields="fields" 
                :busy="isBusy" 
                :items="dataKasMasuk" 
                :currentPage="currentPage" 
                :perPage="perPage"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data kas masuk.
                </template>
                <template v-slot:cell(nominal)="row">
                    <div class="text-right no-wrap" v-if="row.item.nominal !== null">Rp. {{$helper.addThousandSeparator(row.item.nominal)}} </div>
                    <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.nominal)}} </div>
                </template>
                <template v-slot:cell(tanggalPembuatan)="row">
                    <div>{{$helper.changeDateFormat(row.item.tanggalPembuatan)}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.tanggalPembuatan)}}</div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'tansaksi-kas-masuk',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10
            },
            fields: [
                { key: "tanggalPembuatan", label: "Tanggal", sortable:true},
                { key: "nominal", label: "Nominal", sortable:true},
                { key: "keterangan", label: "Keterangan", sortable:true},
            ],
            dataKasMasukAll: [],
            dataKasMasuk: [],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            jenisBarang: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0

            let cabangId = localStorage.getItem("activeCabangId")
            this.query = "?cabangId="+cabangId

            let getDataKasMasuk = this.$axios.get("cabang/kas/masuk/"+this.query).then(response => {
                this.dataKasMasukAll = response.data
                this.dataKasMasuk = response.data
                this.updateTotalItem()
            

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getDataKasMasuk]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        //-----------------  Fungsi Ambil Data DataKasMasuk ----------------- 
        
        getDataKasMasuk(){
            this.dataKasMasuk = this.dataKasMasukAll
            this.toggleBusy()
            this.updateTotalItem()
        },

        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        updateTotalItem(){
            this.rows = this.dataKasMasukAll.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },
        inputKasMasuk(){
            this.$router.push({path: `${this.$route.path}/input`});
        },
    },
    created(){
        this.init()
    }
}
</script>
